import styles from "./styles.module.scss";

export const VARIANTS = {
  h1: { style: styles.h1, gap: "64px" },
  h2: { style: styles.h2, gap: "12px" },
  h4: { style: styles.h4, gap: "8px" },
  p: { style: styles.p, gap: "8px" },
};
